import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicLayout from "./components/PublicLayout";
import AdminLayout from "./components/AdminLayout";

import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import CoinDetail from "./pages/CoinDetail";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminCoins from "./pages/AdminCoins";
import AdminCoinForm from "./pages/AdminCoinForm";
import AdminInquiries from "./pages/AdminInquiries";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/catalog" element={<Catalog />} />
              <Route path="/coin/:id" element={<CoinDetail />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />

            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="coins" element={<AdminCoins />} />
              <Route path="coins/new" element={<AdminCoinForm />} />
              <Route path="coins/:id/edit" element={<AdminCoinForm />} />
              <Route path="inquiries" element={<AdminInquiries />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0A0A0A",
              border: "1px solid rgba(243, 239, 224, 0.15)",
              color: "#F3EFE0",
              borderRadius: 0,
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
